import React from 'react';
import RCSlider from "rc-slider";
import { deep_copy } from "../js-utils";
import {dollarToString} from "../currency-utils";

import {ROOT} from "../fake";

const SquareHandle = (props) => {
  // Custom styles for the square handle
//   const handleStyle = {
//     position: 'absolute',
//     transform: 'translate(-50%, -50%)',
//     width: '20px',        // Specify width of the square handle
//     height: '20px',       // Specify height of the square handle
//     backgroundColor: '#FFF',
//     border: '2px solid #666',
//     cursor: 'pointer',
//     borderRadius: '2px',    // Remove border radius to create a square shape
//       ...props.props.style,
//   };
  const handleStyle = {
        ...props.props.style,
        position: "absolute",
        height: 24,
        width: 24,
        border: "1px solid black",
        cursor: "pointer",
        transform: 'translate(-50%, -50%)',

  }
  const val_str = dollarToString(props.props['aria-valuenow'], true);
  const value_style = {
    display: 'flex',
    justifyContent: 'center',
    transform: 'translate(0, -100%)',
  }
  return (
    <div style={handleStyle}>
      <div style={value_style}>{val_str}</div>
    </div>
  );
};

class Slider {

  static type = "Slider";

  constructor(name, min, max, step, defaultVal, fake) {
    this.name = name;
    this.min = min;
    this.max = max;
    this.step = step;
    this.defaultVal = defaultVal;
    this.type = Slider.type;
    this.fake = fake;
  };

  initState = state => {
    state[this.name.id] = {
      value: this.defaultVal,
      disable: false,
    };
  };

  getDisabled = state => {
    return state[this.name.id].disable;
  }

  setRandomValue = state => {
    const val = parseInt(ROOT.random.num(this.min, this.max, this.step), 10);
    state[this.name.id].value = val;
  }
    
  loadFromState = (appState, componentState) => {
    if (appState) {
      if (appState[this.name.id]) {
        componentState[this.name.id] = {
          value: appState[this.name.id],
          disable: false,
        }
      }
    }
  };
    
  renderSlider = (component, slider_styles, label) => { //} defaultValue, min, max, label, step) => {
    const min_str = dollarToString(this.min, true);
    const max_str = dollarToString(this.max, true) + "+";
    const value = this.getValue(component.state);
    const label_style = {
      marginBottom: "3rem",
    }

    return (
       <div className="sliderWrapper">
        <div className="sliderLabel" style={label_style}>{label}</div>
         <RCSlider
           min={this.min}
           max={this.max}
           step={this.step}
           styles={slider_styles}
           value={value}
           handleRender={SquareHandle}
           onChange={(value)=>{this.onChange(component,value)}}
           />
         <div className="float-left">
             {min_str}
         </div>
         <div className="float-right">
              {max_str}
         </div>
      </div>
    )
  }

  saveToState = state => {
    return {
      [this.name.id]: this.getValue(state),
    }
  }

  onChange = (component, value) => {
    let newState = deep_copy(component.state);
    newState[this.name.id].value = value;
    newState.dirty = true;
    if (this.onChangeCallback) {
        this.onChangeCallback(component, newState, this.name.id);
    }
    component.setState(newState);
  };

  getValue = (state) => {
    return state[this.name.id].value;
  };
}

export {Slider}